import React from "react";
import PropTypes from "prop-types";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Link from "components/link";
import IconButton from "components/icon-button";
import { FormattedMessage } from "react-intl";
import Icon from "components/icon";
import { ConnectedPaginatedTable, TableIconCell, CustomTableRow } from "components/table";
import query from "./query";
import { HeaderCell } from "components/table";
import { DeleteActionWithModal } from "components/buttons";
import mutation from "./mutation";
import { useMutation } from "@apollo/react-hooks";
import { useCurrentCustomerContext } from "components/current-customer-context";
import { Restricted, permissions } from "components/auth";
import styles from "./styles.css.js";
import withStyles from "components/with-styles";

const Header = () => (
  <TableRow>
    <HeaderCell>
      <FormattedMessage id="app.page.roomTemplate" />
    </HeaderCell>
    <TableIconCell />
  </TableRow>
);

const RowComponent = ({ classes, item, refetchData }) => {
  const [deleteRoomTemplate] = useMutation(mutation);
  const { currentCustomerId } = useCurrentCustomerContext();

  const detailsUrl = `/roomTemplate/details/${item.id}/contractId/${item.contractId}`;

  return (
    <CustomTableRow key={item.id} href={detailsUrl}>
      <TableCell>
        <div className={classes.title}>{item.codename}</div>
        <div>{item.description}</div>
      </TableCell>

      <TableIconCell>
          <Link href={detailsUrl} target="_blank" rel="noopener">
              <IconButton>
                  <Icon name="launch" />
              </IconButton>
          </Link>
        <Restricted permissions={[permissions.roomtemplate_manage]}>
          <Link href={`/roomTemplate/edit/${item.id}/contractId/${item.contractId}`}>
            <IconButton>
              <Icon name="edit" />
            </IconButton>
          </Link>
          <Link href={`/roomTemplate/file-editor/${item.id}/contractId/${item.contractId}`}>
            <IconButton>
              <Icon name="code" />
            </IconButton>
          </Link>
          <DeleteActionWithModal
            mutation={deleteRoomTemplate}
            mutationVariables={{
              customerId: currentCustomerId,
              contractId: item.contractId,
              roomTemplateId: item.id,
            }}
            elementNameInResult="deleteRoomTemplate"
            elementToDelete={item.description}
            refetchDataOnSuccess
            refetchData={refetchData}
          />
        </Restricted>
      </TableIconCell>
    </CustomTableRow>
  );
};

RowComponent.propTypes = {
  /**
   ** Elemento a representar en la fila de la tabla
   **/
  item: PropTypes.object,
  /**
   * Función de refetch de datos
   */
  refetchData: PropTypes.func.isRequired,
};

const StyledRowComponent = withStyles(styles)(RowComponent);

const RoomTemplatePaginatedTable = ({ ...props }) => (
  <ConnectedPaginatedTable
    gqlQuery={query}
    headerComponent={Header}
    rowComponent={StyledRowComponent}
    paginatedElementsHandler={data => data.roomTemplates}
    {...props}
  />
);

export default RoomTemplatePaginatedTable;
